import React from "react";
import type { AppToastContextValue } from "./AppToast.types";

export const appToastNoop = () => undefined;

const AppToastContext = React.createContext<AppToastContextValue>({
  addToast: () => -1,
  removeToast: appToastNoop,
});

AppToastContext.displayName = "AppToastContext";

export default AppToastContext;
